module.exports = __webpack_public_path__ + "static/media/amz_LEFT_VIEW_04.6120aaea.svg";